import { WasteReturnRegFieldKeys } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";

/**
 * Verified against `Planning/SupportingDocs/2025 Q3 Waste Return.xlsx` (EA template v16.10):
 * - Geography: named range `LA_PickList2` → `Look Up Values!B2:B442` (authority descriptions; no separate code column)
 * - EWC: named range `EWC` → catalogue column on `Look Up Values` (e.g. C9:C1115)
 * - D/R received: named range `DandR` → `Look Up Values!S2:S112`
 * - D/R removed: named range `OutputDaR` → `Look Up Values!W2:W28`
 */
export interface IEaListSourceDefault {
    regFieldKey: string;
    sheet: string;
    column: string;
    startRow: number;
    endRow: number;
}

export const EA_LIST_SOURCE_DEFAULTS = {
    geography: {
        regFieldKey: WasteReturnRegFieldKeys.Geography,
        sheet: "Look Up Values",
        column: "B",
        startRow: 2,
        endRow: 442,
    },
    ewc: {
        regFieldKey: WasteReturnRegFieldKeys.Ewc,
        sheet: "Look Up Values",
        column: "G",
        startRow: 2,
        endRow: 1115,
    },
    disposalRecoveryReceived: {
        regFieldKey: WasteReturnRegFieldKeys.EaDrReceived,
        sheet: "Look Up Values",
        column: "S",
        startRow: 2,
        endRow: 112,
    },
    disposalRecoveryRemoved: {
        regFieldKey: WasteReturnRegFieldKeys.EaDrRemoved,
        sheet: "Look Up Values",
        column: "W",
        startRow: 2,
        endRow: 28,
    },
    /** Named range `Facility_Type` → Look Up Values!E2:E150 */
    facilityOperation: {
        regFieldKey: WasteReturnRegFieldKeys.FacilityOperation,
        sheet: "Look Up Values",
        column: "E",
        startRow: 2,
        endRow: 150,
    },
    /** Named range `TCM_List` / `TCMType` → Look Up Values!AB2:AB4 */
    technicalCompetence: {
        regFieldKey: WasteReturnRegFieldKeys.TechnicalCompetence,
        sheet: "Look Up Values",
        column: "AB",
        startRow: 2,
        endRow: 4,
    },
} as const satisfies Record<string, IEaListSourceDefault>;
